<template>
  <div :style="'min-width:' +  minWidth" :class="{'form-floating': !simple}">
    <v-select :taggable="taggable" @listener :class="[background]" :disabled="disabled" @search="onSearch"
              :required="required"
              :label="text" :code="code" :multiple="multiple"
              :placeholder="placeholder || trans('general.defaults.type_to_search')"
              v-model="model" v-on="$listeners" :filterable="false" :options="list ?? []">
      <template #search="{attributes, events}">
        <input class="vs__search" :required="required && !model" v-bind="attributes" v-on="events"/>
      </template>
      <template #selected-option="option">
        <slot name="selected-option" :option="option"></slot>
      </template>
      <template #option="option">
       <slot name="option" :option="option"></slot>
      </template>
    </v-select>
    <label v-if="!simple"> {{ label || trans('general.defaults.type_to_search') }}  <span v-if="required">*</span> </label>
    <!--  To support FormData load    -->
    <input type="hidden" :class="{'is-invalid': error}" :required="required" :name="name" :value="model ? model.value : ''">
    <small v-if="help" class="form-text text-muted m-sm-2">{{help}}</small>
    <div class="invalid-feedback d-block" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import AbstractAtom from "./AbstractAtom.vue";

export default {
  name: "BasicSelect",
  extends: AbstractAtom,
  props: {
    options: Array|Function|Promise,
    value: Object|String|Number,
    name: String,
    placeholder: String,
    label: String,
    taggable: Boolean,
    multiple: {
      type: Boolean,
      default: false
    },
    code:{
      type: String,
      default: 'code'
    },
    text:{
      type: String,
      default: 'label'
    },
    background: {
      type: String,
      default: 'form-control'
    },
    help: {
      type: String,
      required: false,
    },
    simple: Boolean,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    error: String,
    minWidth: {
      type: String,
      default: '200px'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  watch: {
    model: function (val) {
      this.$emit('change', val)
      this.$emit('input', val)
    },
    value: function (val) {
      this.model = this.list.filter(item => item.value === val)[0] ?? val;
    },
    list: function () {
      if (typeof this.model !== 'object') {
        this.model = this.list.filter(item => item.value === this.value)[0] ?? this.value;
      }
    },
    options: function () {
      this.initOptions()
    }
  },
  components: {
    vSelect
  },
  data() {
    return {
      model: null,
      list: [],
    }
  },
  methods: {
    initOptions() {
      typeof this.options === 'function' ? this.options().then(data => this.setOptions(data)) : this.setOptions(this.options);
    },
    onSearch(search, loading) {
      this.search(search, loading, this);
    },
    search: _.debounce((search, loading, vm) => {
      vm.$emit('search', search, loading, vm)
    }, 350),
    setOptions(options) {
      this.list = options;
    }
  },
  mounted() {
    if (this.value) {
      this.model = this.value
    }
    this.initOptions()
  }
}
</script>

<style >
.v-select {
  height: auto !important;
}
</style>
